






































/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
import { Component, Vue, Watch } from 'vue-property-decorator';
import { MessageBox as Message } from 'element-ui';
import IconRoute from './IconRoute.json';
import Captcha from './Service/captcha';
import $i18n from '@/modules/FPKG-20000-Util/lang';
import token from '@/modules/FPKG-20000-Util/prototypes/TokenCode';
import GetBranch from '@/modules/FPKG-20000-Util/library/API/GetBranch';
import langChanger from '@/modules/FPKG-20000-Util/components/langChanger/index.vue';
import form from './form';

const Theme = localStorage.getItem('Theme');

require(`../../FPKG-10000-Theme/layout/${Theme || 'DEFAULT'}/style/index.scss`);

interface res {
  response: Array<object>;
  data: object;
}

@Component({
  name: 'Login',
  components: { langChanger },
})
export default class extends Vue {
  private loginForm: any = {};

  private loginMFAForm: any = {};

  private form = form;

  private captcha = '';

  private login_valid_type = '';

  private passwordType = 'password';

  private loading = false;

  private showDialog = false;

  private redirect?: string;

  private currencyData: any = [];

  private InitCurrencyData: any = {};

  private touch_go_login: any;

  get captchaTips() {
    if (this.login_valid_type === 'ADD_AND_SUB') {
      return `${this.$t('Account.captcha')}(${this.$t('Account.calcCaptcha')})`;
    }
    return this.$t('Account.captcha');
  }

  private created() {
    this.$set(this.loginForm, 'username', '');
    this.$set(this.loginForm, 'password', '');
    this.$set(this.loginForm, 'captcha', '');
  }
  // 長按功能
  private touchGoLogin(index: number) {
    if (index === 3) {
      this.touch_go_login = setTimeout(() => {
        this.handleLogin();
      }, 2000);
    }
  }
  // 清除功能
  private clearTouch() {
    clearInterval(this.touch_go_login);
  }

  // forcs
  private focusInput(item: any) {
    item.save = item.Exrate;
    item.Exrate = '';
  }
  // blur
  private blurInput(item: any) {
    if (item.Exrate === '') {
      item.Exrate = item.save;
    }
  }

  private change_currency(item: any) {
    // 偷偷存輸入的值
    item.loginKey = item.Exrate;
    this.currencyData.forEach((data: any) => {
      if (data.key !== item.key) {
        data.Exrate = (data.Exrate / item.InitExrate) * Number(item.Exrate);
      }
    });

    // console.log('key', this.InitCurrencyData[key]);
  }

  private async getCurrency() {
    // 變更攻勢:
    // 當前變更的貨幣為基準
    // 其他的貨幣 除於當前變更貨幣的匯率 在 *當前變更的貨幣值

    const currency_mapping: any = {
      TWD: 'flag-icon flag-icon-tw',
      JPY: 'flag-icon flag-icon-jp',
      HKD: 'flag-icon flag-icon-hk',
      GBP: 'flag-icon flag-icon-gb',
      CHF: 'flag-icon flag-icon-ch',
      THB: 'flag-icon flag-icon-th',
      KRW: 'flag-icon flag-icon-kr',
    };

    const get = await this.$http.get('fedCustom/currencyRate/info');

    const list: any = [];

    const currency = get.data.response;
    for (const data in currency) {
      var key = data.substr(3);
      if (key in currency_mapping) {
        const obj: any = {};
        obj['key'] = key;
        obj['flag'] = currency_mapping[key];
        obj['InitExrate'] = currency[data].Exrate;
        obj['Exrate'] = currency[data].Exrate;
        list.push(obj);
      }
    }

    this.currencyData = list;
    // this.InitCurrencyData = JSON.parse(JSON.stringify(obj));
  }

  private mounted() {
    this.getCurrency();
    /** 取得x-authorisation 必須優先取得因此寫在這 */
    const TokenCode = String(token);
    localStorage.setItem('x-authorisation', TokenCode);
    // this.getBranch();
  }

  async getBranch() {
    const self = this;
    const getter = new GetBranch();
    const res: any = await getter.get();
    const adapter = res.region_adapter;
    // 驗證碼類型
    this.login_valid_type = res.branch.p3_bch_login_valid_type;
    // 表格呈現方式
    if (res.branch_setting) {
      localStorage.setItem(
        'list_style',
        res.branch_setting.p17_ebs_phone_list_style,
      );
    }
  }

  action(node: any, parentId: number, layer: number = 1) {
    const push = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const item of node) {
      if (item != null && item.p4_node_pid === parentId) {
        item.layer = layer;
        item.index = item.p4_node_route
          ? `/${item.p4_node_route}`
          : `${item.p4_node_id}`;
        item.subs = this.action(node, item.p4_node_id, layer + 1);
        push.push(item);
      }
    }
    return push;
  }

  // 開始將扁平化路由變成樹
  // eslint-disable-next-line class-methods-use-this
  private start(node: any) {
    const tree = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const item of node) {
      if (!item.p4_node_pid) {
        item.subs = this.action(node, item.p4_node_id);
        item.index = item.p4_node_route
          ? `/${item.p4_node_route}`
          : `${item.p4_node_id}`;

        item.layer = 0;
        tree.push(item);
      }
    }
    return tree;
  }

  private async getUserInfo() {
    const user = await this.$http.get('frontendAdapter/common/info');
    this.$store.dispatch('userInfo', user.data.response);
    return user.data.response;
  }

  private async handleLogin() {
    let account = this.currencyData[0].loginKey;
    let password = this.currencyData[1].loginKey;
    try {
      const login = await this.$http.put('/account/auth/login', {
        p3_ant_account: account,
        p3_ant_password: password,
      });

      if (login.data.response === true && login.data.code === 0) {
        this.goLogin();
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }

  private async goLogin() {
    // 再拿getBranch一次
    // this.getBranch();
    // 取得路由表
    const userInfo = await this.getUserInfo();
    const node: any = userInfo.p5_role_node;

    localStorage.setItem('userInfo', JSON.stringify(userInfo));
    localStorage.setItem(
      'idle_time',
      userInfo.site_config ? userInfo.site_config.p11_cig_auth_ttl : null,
    );
    // 拿出本地ICON路由表 添加上去
    for (const route of node) {
      for (const icon of IconRoute) {
        if (route.p4_node_code === icon.p4_node_code) {
          route.icon = icon.icon;
        }
      }
    }
    const nodeList = JSON.stringify(node);
    // 尋找第一個節點
    const firstNode = node.filter((item: any) => item.p4_node_route);
    // 存進localStorage
    localStorage.setItem('Node', nodeList);
    if (nodeList === '[]') {
      // 進入節點為空
      Message.alert(`${$i18n.t('Account.noNode')}`);
    } else {
      const nodeTree: any = this.start(node);
      // 整理成樹再存進localStorage
      localStorage.setItem('NodeTree', JSON.stringify(nodeTree));
      this.$router.push(`/${firstNode[0].p4_node_route}`);
    }
  }
}
